import { GfsCatalogListItem } from "@/services/backend/gfs/catalog/types";

export function preferredGfsCatalogId(
  catalogs: GfsCatalogListItem[],
  customerId: string,
): string {
  return (
    catalogs.find((catalog) => catalog.customerId === customerId)?.id ??
    catalogs.find((catalog) => !catalog.customerId && catalog.isFallback)?.id ??
    ""
  );
}
